export default "__VITE_ASSET__CBrTXD5I__"